import React, { createContext, useContext, useState, useEffect } from 'react';
import en from '../locales/en.json';
import ko from '../locales/ko.json';
import ru from '../locales/ru.json';
import pt from '../locales/pt.json';
import es from '../locales/es.json';
import ar from '../locales/ar.json';
import hi from '../locales/hi.json';
import ja from '../locales/ja.json';
import zh from '../locales/zh.json';
import fr from '../locales/fr.json';

const translations = { en, ko, ru, pt, es, ar, hi, ja, zh, fr };

// 지원 언어 목록 (우선순위 순)
const SUPPORTED_LANGS = ['ko', 'ru', 'pt', 'es', 'ar', 'hi', 'ja', 'zh', 'fr', 'en'];

// RTL(우→좌) 언어
const RTL_LANGS = ['ar'];

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  const [isRtl, setIsRtl] = useState(false);

  useEffect(() => {
    try {
      let detected = 'en';
      if (window.Telegram && window.Telegram.WebApp) {
        const tgLang = window.Telegram.WebApp.initDataUnsafe?.user?.language_code || 'en';
        // Telegram language_code 예: 'ko', 'ru', 'pt-br', 'zh-hans'
        const matched = SUPPORTED_LANGS.find(l => tgLang.toLowerCase().startsWith(l));
        detected = matched || 'en';
      }
      setLang(detected);
      setIsRtl(RTL_LANGS.includes(detected));

      // RTL 언어: HTML dir 속성 설정
      document.documentElement.setAttribute('dir', RTL_LANGS.includes(detected) ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', detected);
    } catch (e) {
      console.warn('I18n initialization error:', e);
    }
  }, []);

  const t = (key) => {
    return translations[lang]?.[key] || translations['en']?.[key] || key;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, isRtl }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
